import { IconButton, Stack, Tooltip, Typography } from '@mui/material'
import { FC } from 'react'
import MessageQuestionCircleIcon from '../../../../assets/icons/MessageQuestionCircle.svg?react'

export const HelpButton: FC = ({stepOnboarding}) => (
    <Tooltip
        title={
            <Stack p={2.5} gap={2.5}>
                <Stack gap={2}>
                    <Typography variant="h6">
                        Чтобы получить лучший результат, давайте ИИ четкую задачу
                    </Typography>
                    <Stack gap={1.5}>
                        <Typography variant="caption2">Попробуйте эту простую формулу:</Typography>
                        <Stack gap={1}>
                            <Typography variant="caption">
                                <Typography variant="caption2">• Роль:</Typography> Назначьте ИИ
                                эксперта
                            </Typography>
                            <Typography variant="caption">
                                <Typography variant="caption2">• Задача:</Typography> Опишите, что
                                нужно сделать
                            </Typography>
                            <Typography variant="caption">
                                <Typography variant="caption2">• Детали:</Typography> Добавьте
                                контекст — тему, целевую аудиторию, стиль, формат
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack gap={1.5}>
                    <Typography variant="caption2">Пример промпта:</Typography>
                    <Typography variant="caption">
                        Представь, что ты опытный шеф-повар и специалист по планированию меню.
                        Составь план ужинов на рабочую неделю (с понедельника по пятницу). Семья из
                        трёх человек: двое взрослых и ребёнок 10 лет. Мы хотим, чтобы блюда были
                        разнообразными, полезными и готовились не дольше 40 минут. Пожалуйста,
                        исключи из меню жареное и морепродукты (кроме рыбы). К каждому ужину
                        предложи простой гарнир. Цель — сэкономить время и питаться сбалансированно.
                        Отвечай дружелюбно, как будто ты заботливая бабушка, рассказывающая меню
                        внуку.
                    </Typography>
                </Stack>
                <Typography variant="caption2">
                    Постарайтесь дать максимум информации в одном запросе. Чем больше подробностей и
                    ясности в вашем запросе, тем точнее и полезнее будет ответ.
                </Typography>
            </Stack>
        }
        placement="left-start"
        slotProps={{
            tooltip: {
                sx: {
                    maxWidth: '496px',
                    borderRadius: '8px',
                    backgroundColor: '#FFFFFF',
                    p: 0,
                    boxShadow: '0px 4px 19.2px 0px #0000001A',
                },
            },
        }}>
        <IconButton
            disabled={stepOnboarding !== 100}
            sx={{
                position: 'absolute',
                zIndex: 99,
                top: 6,
                right: 6,
                color: '#8F93A3',
                ':hover': {
                    color: '#006CFD',
                },
            }}>
            <MessageQuestionCircleIcon />
        </IconButton>
    </Tooltip>
)
